(function () {
  'use strict';

  angular
      .module('tf.retailer.Analytics')
      .directive('tfcMetricSummary', tfcMetricSummary);

  // @ngInject
  function tfcMetricSummary() {
    return {
      controller : function ($filter, $translate, $stateParams, AnalyticsConfig) {
        var vm = this;
        var percentFilter = $filter('percent'),
            numberFilter = $filter('number');
        vm.metrics = {};
        vm.viewType = AnalyticsConfig.viewType($stateParams.experiment);

        vm.updateVariations = function () {
          // get the lists of variations from each metric chart
          var variationSets = _.map(vm.chartMetrics, function (metric) {
            return _.map(metric.variations, 'variation');
          });

          // validate they're all in the same order
          var first = _.head(variationSets);
          _.each(_.tail(variationSets), function (varSet) {
            if (!_.isEqual(first, varSet)) {
              throw new Error('Metrics returned variations in a different order');
            }
          });
          // array of VariationType strings
          vm.variations = first;

          // Only add the incoming chart metrics to our list of metrics the first time.
          // This prevents the summary table from updating when the user changes the range / interval
          _.each(vm.chartMetrics, function (metric, name) {
            if (!vm.metrics[name]) {
              vm.metrics[name] = metric;
            }
          });
        };

        vm.variationSign = function (variation) {
          // delta variations should always have a sign
          return variation.variation === 'delta'
          && variation.summary > 0
              ? '+' : '';
        };

        vm.variation = function (metric, variation) {
          return _.find(_.get(vm.metrics[metric], 'variations'), { variation : variation });
        };

        vm.summary = function (metric, variationType) {
          var variation = vm.variation(metric, variationType),
              summaryText = vm.variationSign(variation);

          var unit = variation.unit;
          if (unit === 'percent') {
            summaryText += percentFilter(variation.summary);
          } else if (unit) {
            summaryText += $translate.instant('currency.' + unit, { value : variation.summary });
          } else {
            summaryText += numberFilter(variation.summary);
          }

          if (variation.sigma != null) {
            // todo: 1.6 is duplicated in metric chart, and should not be hard-coded
            summaryText += ' &plusmn; ' + percentFilter(variation.sigma * 1.96);
          }

          return summaryText;
        };
      },
      controllerAs : 'vm',
      bindToController : true,
      templateUrl : 'Analytics/MetricSummary.tmpl.html',
      scope : {
        // metric data coming from charts
        chartMetrics : '=metrics',
        experimentType : '@',
        metricNames : '='
      },
      link : function ($scope, $el, $attrs, vm) {
        // can't use $watch('', fn) because vm.chartMetrics will only change once.
        // can't use $watch('', fn, objectEquality = true) that'd be non-performant
        $scope.$watchCollection('vm.chartMetrics', function (metrics) {
          if (metrics) {
            vm.updateVariations();
          }
        });
      }
    };
  }

})();
